import { StyleSheet } from 'react-native'
import { platformSelect } from '../../utils/platformUtils'

const styles = StyleSheet.create({
    likesCount: {
        fontSize: 11,
        fontWeight: 'normal',
        marginRight: 4,
        textAlign: 'right',
    },
    commentsPostContainer: {
        flex: 1,
        flexDirection: 'row',
        paddingTop: 12,
        marginRight: 10,
        marginLeft: 10,
        justifyContent: 'space-between',
    },
    commentsPost: {
        // width: '90%',
        flex: 1,
    },
    commentsCTA: {
        marginHorizontal: 10,
        marginTop: 8,
        marginBottom: 0,
    },
    commentsLike: {
        width: 20,
        height: 20,
        paddingLeft: 3,
    },
    commentsLikeCuore: {
        justifyContent: 'top',
        alignItems: 'center',
        marginTop: 0,
    },
})
export default styles
